import React, {useEffect, useState} from 'react';
import {
    Center, Flex, HStack,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import {useDispatch, useSelector} from 'react-redux';
import {resetResponseState, setFlag, setIsPopup} from "../features/responseSlice";
import {useExchangeApi} from "../api/ExchangeAPI";
import {setActionPayload, setActionType} from "../features/authorizationSlice";
import {ACTION_TYPES} from "../app/actionTypes";

const flagIconMap = {
    0: "Images/check.png",
    1: "Images/check.png",
    435: "Images/warning.png",
    436: "Images/warning.png",
};
function ValidationPopup({onOpenQrAfterGenerate}) {
    const [isProceedExchange, setIsProceedExchange] = useState(false);
    const [icon, setIcon] = useState("Images/caution.png");


    const {isOpen, onOpen, onClose} = useDisclosure(); // use useDisclosure instead of useState

    const {
        flag,
        responseTitle,
        responseDescription,
        isPopup,
        info
    } = useSelector((state) => state.transferResponse);

    const {getExchangeRate, exchangeRate} = useExchangeApi();

    const dispatch = useDispatch();

    useEffect(() => {
        if (isPopup) {
            onOpen();
        } else {
            onClose();
        }
    }, [flag, isPopup, onOpen, onClose]);

    useEffect(() => {
        if (flag === 11) {
            setIsProceedExchange(true);
            getExchangeRate();
        }
    }, [flag]);

    const onClosePopup = () => {
        dispatch(setFlag(null));
        dispatch(setIsPopup(false));
        onClose();
    }

    function InitiateExchange() {
        dispatch(setActionType(ACTION_TYPES.INITIATE_EXCHANGE));
        dispatch(setActionPayload({
            ExchangeFromAmount: info?.amount,
            ExchangeFromCurrencyID: info?.currencyFrom,
            ExchangeToCurrencyID: info?.currencyTo,
            ExchangeBuy: exchangeRate?.Buy,
            ExchangeSell: exchangeRate?.Sell,

        }));
        onClosePopup();
        onOpenQrAfterGenerate();
    }

    useEffect(() => {
        if(flag!==null){
            const iconPath = flagIconMap[Number(flag)] || "Images/caution.png";
            setIcon(iconPath);
        }

    }, [flag]);

    // useEffect(() => {
    //     switch (Number(flag)){
    //         case 0:
    //             setIcon("Images/check.png");
    //             break;
    //         case 1:
    //             setIcon("Images/check.png");
    //             break;
    //         case 435:
    //             setIcon("Images/warning.png");
    //             break;
    //         case 436:
    //             setIcon("Images/warning.png");
    //             break;
    //         default:
    //             setIcon("Images/caution.png");
    //     }
    // }, [flag]);

    return (
        <Modal isCentered isOpen={isOpen} onClose={onClosePopup}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader textAlign="center" textTransform="uppercase">
                    <div className="modal-header-image">
                        <img src={icon} alt=""/>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Center>
                        <Text textAlign="center" fontSize={16} fontWeight={700}>
                            {responseTitle}
                        </Text>
                    </Center>
                    <Center>
                        <Text textAlign="center" color={'#7588A0'} style={{whiteSpace: "pre-line"}} white-space="pre-line">
                            {responseDescription}
                        </Text>
                    </Center>
                    {
                        flag === 11 ?
                            <Flex justify="space-between">
                                <button
                                    id="closeTransferModalBtn"
                                    onClick={() => {
                                        onClosePopup();
                                    }}
                                >
                                    Not Now
                                </button>
                                <button
                                    id="closeModalBtn"
                                    onClick={() => {
                                        InitiateExchange();
                                    }}
                                >
                                    Proceed
                                </button>
                            </Flex>
                            :
                            <Center>
                                <button
                                    id="closeModalBtn"
                                    onClick={() => {
                                        onClosePopup();
                                    }}
                                >
                                    OK
                                    {/*{[1, 11, 436].includes(flag)? "Continue" : "OK"}*/}
                                </button>
                            </Center>
                    }

                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default ValidationPopup;
